var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sku-price"},[_c('div',{staticClass:"sku-price-type"},[_vm._v("\n    优惠价:\n    "),_c('span',[_vm._v("\n      ¥\n      "),_c('em',[_vm._v(_vm._s(_vm._f("skuPrice")(_vm.sku)))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }